<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  const links = document.links; 
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank'; 
      links[i].rel = 'noreferrer noopener'; 
  } 
}

var myInput = document.getElementsByClassName("articleLookbook-des");
if(myInput[0]) {
if (myInput[0].innerHTML) {  
document.getElementsByClassName("articleLookbook-des")[0].insertAdjacentHTML("beforeBegin", '<input type="checkbox" id="read_more" role="button"><label for="read_more" onclick=""><span>Read More</span><span>Read Less</span></label>');
}}

/** Refurbished product icon*/
  var elem = document.createElement("img");
  elem.setAttribute("src", "https://cdn.shopify.com/s/files/1/0841/4022/8908/files/GB-REFURB-ICON.png?v=1723426865");
  elem.setAttribute("class", "refurb-icon");
  elem.setAttribute("alt", "refurbished-img");
if($("[class*='productView-image'][class*='refurb']")[0]) {
  $("[class*='productView-image'][class*='refurb']")[0].appendChild(elem);
}


